import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"

import backgroundImg from "../../images/solutions/chatApp/back.svg"

import builtImg from "../../images/solutions/chatApp/built.png"
import integrateImg from "../../images/solutions/chatApp/integrate.png"

import audioVideoImg from "../../images/solutions/chatApp/audiovideo.png"
import fileShareImg from "../../images/solutions/chatApp/fileShare.png"
import statusImg from "../../images/solutions/chatApp/status.png"

import CarouselImg1 from "../../images/solutions/chatApp/Chat app.png"

import Constants from "../../constants/solutions.json"

const carouselVideos = [
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
  {
    videoUrl1: "fsfsdfsdf",
    videoUrl2: "fsfsdfsdf",
    videoUrl3: "fsfsdfsdf",
  },
]

const carouselData = [
  {
    title: "",
    description:
      Constants.SOLUTIONS.chatApplications.carouselData.i1.description,
    img: CarouselImg1,
  },
]
const GridData1 = [
  {
    title: Constants.SOLUTIONS.chatApplications.GridDataArray1.i1.title,
    description:
      Constants.SOLUTIONS.chatApplications.GridDataArray1.i1.description,
    img: builtImg,
  },
  {
    title: Constants.SOLUTIONS.chatApplications.GridDataArray1.i2.title,
    description:
      Constants.SOLUTIONS.chatApplications.GridDataArray1.i2.description,
    img: integrateImg,
  },
]

const GridData2 = [
  {
    title: Constants.SOLUTIONS.chatApplications.GridDataArray2.i1.title,
    description:
      Constants.SOLUTIONS.chatApplications.GridDataArray2.i1.description,
    img: audioVideoImg,
  },
  {
    title: Constants.SOLUTIONS.chatApplications.GridDataArray2.i2.title,
    description:
      Constants.SOLUTIONS.chatApplications.GridDataArray2.i2.description,
    img: fileShareImg,
  },
  {
    title: Constants.SOLUTIONS.chatApplications.GridDataArray2.i3.title,
    description:
      Constants.SOLUTIONS.chatApplications.GridDataArray2.i3.description,
    img: statusImg,
  },
]

const ChatApplications = () => (
  <MainLayout>
    <SEO
      title="ChatApplications"
      description="Modern Chat applications possess many functionalities rather than a simple text between the two parties.Among the demanding requirements include audio call,video call and file sharing.
            Building instant messaging apps for business. Best team chat app"
      pagePath="/solutions/chat-applications"
      schema={`{
              "@context": "https://meetrix.io/solutions/chat-applications",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.SOLUTIONS.chatApplications.MainLayout.title}
      description={Constants.SOLUTIONS.chatApplications.MainLayout.description}
      blueTitle={Constants.SOLUTIONS.chatApplications.MainLayout.blueTitle}
      blueLink=""
      background={backgroundImg}
    />
    <GridView
      twoCol
      noButton
      // title={Constants.SOLUTIONS.chatApplications.GridView1.title}
      description={Constants.SOLUTIONS.chatApplications.GridView1.description}
      bottomTitle={Constants.SOLUTIONS.chatApplications.GridView1.bottomTitle}
      data={GridData1}
    />
    <GridView
      noButton
      title={Constants.SOLUTIONS.chatApplications.GridView2.title}
      description={Constants.SOLUTIONS.chatApplications.GridView2.description}
      // bottomTitle={Constants.SOLUTIONS.chatApplications.GridView2.bottomTitle}
      data={GridData2}
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default ChatApplications
